"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("./change-log.component.scss");
var Subject_1 = require("rxjs/Subject");
var change_log_service_1 = require("./change-log.service");
var operators_1 = require("rxjs/operators");
var zip_1 = require("rxjs/observable/zip");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var Observable_1 = require("rxjs/Observable");
var lodash_1 = require("lodash");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var meta_field_1 = require("@synisys/idm-kb-service-client-js/src/model/meta-field");
var noop_1 = require("rxjs/util/noop");
var router_1 = require("@angular/router");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var change_log_settings_component_1 = require("./change-log-settings.component");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var ChangeLogComponent = /** @class */ (function () {
    function ChangeLogComponent(_changeLogService, _deService, _router, _route, _classifierService, _authentication, _authorizationService, _kbService) {
        this._changeLogService = _changeLogService;
        this._deService = _deService;
        this._router = _router;
        this._route = _route;
        this._classifierService = _classifierService;
        this._authentication = _authentication;
        this._authorizationService = _authorizationService;
        this._kbService = _kbService;
        this.OperationType = change_log_service_1.OperationType;
        this.ready = false;
        this.hasChangeLogHistoryViewPermission = false;
        this.hasChangesViewPermission = false;
        this.destroyNotifier = new Subject_1.Subject();
        this._logs = [];
        this._entityNameCache = new Map();
        this._workFlowStateFieldCache = new Map();
        this._workFlowStatesCache = new Map();
        this._enoughLogs = false;
        this._loadItemCount = 20;
        this._loadIndex = 1;
    }
    Object.defineProperty(ChangeLogComponent.prototype, "logs", {
        get: function () {
            return this._logs;
        },
        enumerable: true,
        configurable: true
    });
    ChangeLogComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (lodash_1.isNil(this.instanceId) && !lodash_1.isNil(this.entity)) {
            this.instanceId = this.entity.getInstanceId();
        }
        if (!lodash_1.isNil(this.instanceId)) {
            this.settlePermissions()
                .pipe(operators_1.switchMap(function () {
                return _this.hasChangeLogHistoryViewPermission
                    ? _this._changeLogService.storeAllChangeLogs(_this.category, _this.instanceId, _this._userId, _this._loadItemCount)
                    : Observable_1.Observable.of(-1);
                // return this._changeLogService.storeAllChangeLogs(this.category,
                //                                                  this.instanceId,
                //                                                  this._userId, this._loadItemCount);
            }), operators_1.tap(function (count) {
                if (count < 0) {
                    _this.ready = false;
                }
                else {
                    _this.ready = true;
                    _this._packageCount = count;
                    _this.digOutMoreLogs();
                }
            }), operators_1.takeUntil(this.destroyNotifier))
                .subscribe(noop_1.noop, console.error);
        }
    };
    ChangeLogComponent.prototype.ngOnDestroy = function () {
        this.destroyNotifier.next();
        this.destroyNotifier.complete();
        for (var i = 1; i < this._packageCount; i++) {
            localStorage.removeItem("log_" + i);
        }
        localStorage.removeItem('wf_logs');
    };
    ChangeLogComponent.prototype.getStateName = function (category, entityData) {
        var _this = this;
        return this.getWorkflowStateField(category).pipe(operators_1.switchMap(function (fieldWF) {
            return zip_1.zip(_this.getWorkflowStates(category), Observable_1.Observable.of(fieldWF));
        }), operators_1.map(function (data) {
            var states = data[0];
            var fieldWF = data[1];
            if (!lodash_1.isEmpty(fieldWF) &&
                !lodash_1.isEmpty(states) &&
                !lodash_1.isNil(entityData) &&
                entityData.hasOwnProperty(fieldWF)) {
                var wfState = states.find(function (state) { return state.id === entityData[fieldWF]; });
                return !lodash_1.isNil(wfState)
                    ? wfState.name[_this.currentLanguageId]
                    : '';
            }
            return '';
        }), operators_1.takeUntil(this.destroyNotifier));
    };
    ChangeLogComponent.prototype.viewChange = function (log) {
        var url;
        var baseUrl = window.location.href.replace(this._router.url, '');
        var dynamicDePath = this.calculateDynamicDeSubPath();
        if (log.operationType === change_log_service_1.OperationType.CREATE) {
            url = this._router.createUrlTree([
                "./diff-view/" + this.category + "/" + this.instanceId + "/" + this._userId + "/" + log.modifiedDate,
            ], { relativeTo: this._route.parent });
        }
        if (log.operationType === change_log_service_1.OperationType.UPDATE) {
            url = this._router.createUrlTree([
                "./diff-view/" + this.category + "/" + this.instanceId + "/" + this._userId + "/" + log.modifiedDate + "/" + log.nextModifiedDate,
            ]);
        }
        window.open(baseUrl + dynamicDePath + url, '_blank');
    };
    Object.defineProperty(ChangeLogComponent.prototype, "enoughLogs", {
        get: function () {
            return this._enoughLogs;
        },
        enumerable: true,
        configurable: true
    });
    ChangeLogComponent.prototype.digOutMoreLogs = function () {
        var _this = this;
        var newPackageOfLogs = JSON.parse(localStorage.getItem("log_" + this._loadIndex));
        newPackageOfLogs.forEach(function (log) {
            log.date = new Date(log.modifiedDate).toUTCString();
            if (log.actionName === 'audit_service.action.workflow') {
                log.operationType = change_log_service_1.OperationType.WORKFLOW;
                var nextWfLog = newPackageOfLogs.find(function (wfLog) { return wfLog.modifiedDate === log.nextModifiedDate; });
                if (!lodash_1.isNil(nextWfLog)) {
                    log.nextWfData = nextWfLog.data;
                }
                else {
                    var newMoreLogs = JSON.parse(localStorage.getItem("log_" + (_this._loadIndex + 1)));
                    if (!lodash_1.isNil(newMoreLogs) && lodash_1.isArray(newMoreLogs)) {
                        var newNextWfLog = newMoreLogs.find(function (wfLog) { return wfLog.modifiedDate === log.nextModifiedDate; });
                        if (!lodash_1.isNil(newNextWfLog)) {
                            log.nextWfData = newNextWfLog.data;
                        }
                    }
                }
            }
        });
        (_a = this._logs).push.apply(_a, newPackageOfLogs);
        this._loadIndex += 1;
        if (this._loadIndex > this._packageCount) {
            this._enoughLogs = true;
        }
        var _a;
    };
    ChangeLogComponent.prototype.getEntityName = function (category, instanceId) {
        var _this = this;
        var categoryKey = lodash_1.isNil(category) || lodash_1.isNil(instanceId)
            ? ''
            : category + "_" + instanceId;
        if (this._entityNameCache.has(categoryKey)) {
            return this._entityNameCache.get(categoryKey);
        }
        else {
            var replaySubject_1 = new ReplaySubject_1.ReplaySubject(1);
            this._entityNameCache.set(categoryKey, replaySubject_1);
            if (lodash_1.isEmpty(categoryKey)) {
                this._entityNameCache.set('', replaySubject_1);
                replaySubject_1.next('');
            }
            else {
                this._deService
                    .loadEntityByInstanceId(category, instanceId)
                    .pipe(operators_1.switchMap(function (entity) {
                    return _this._classifierService.getEntityName(category, entity);
                }), operators_1.takeUntil(this.destroyNotifier))
                    .subscribe(function (name) { return replaySubject_1.next(name); }, console.error);
            }
            return replaySubject_1;
        }
    };
    ChangeLogComponent.prototype.calculateDynamicDeSubPath = function () {
        var dynamicDeSuffix = this._router.url.match(/\/dynamic-de\/.+/);
        if (!lodash_1.isNil(dynamicDeSuffix) &&
            !lodash_1.isEmpty(dynamicDeSuffix) &&
            dynamicDeSuffix.length > 0) {
            return this._router.url
                .replace(dynamicDeSuffix[0], '')
                .concat('/dynamic-de');
        }
        return '';
    };
    ChangeLogComponent.prototype.getWorkflowStates = function (category) {
        if (this._workFlowStatesCache.has(category)) {
            return this._workFlowStatesCache.get(category);
        }
        else {
            var replaySubject_2 = new ReplaySubject_1.ReplaySubject(1);
            this._workFlowStatesCache.set(category, replaySubject_2);
            this._changeLogService
                .getStates(category)
                .pipe(operators_1.tap(function (states) {
                replaySubject_2.next(states);
            }), operators_1.takeUntil(this.destroyNotifier))
                .subscribe(noop_1.noop, console.error);
            return replaySubject_2;
        }
    };
    ChangeLogComponent.prototype.settlePermissions = function () {
        var _this = this;
        return this._authentication.getUserData().pipe(operators_1.switchMap(function (userData) {
            _this._userId = userData.userId;
            return _this._authorizationService.getPermissionAccessValue(_this._userId, 'b1eb916b-97a5-46d7-a17f-1c9b0ece317f');
        }), operators_1.switchMap(function (permissionValue) {
            _this.hasChangeLogHistoryViewPermission =
                permissionValue.access === idm_authorization_client_js_1.Access.FULL;
            return _this._authorizationService.getPermissionAccessValue(_this._userId, '8e78fbf8-e7f4-4408-9f1f-812e9e0d2f8e');
        }), operators_1.map(function (permissionValue) {
            _this.hasChangesViewPermission =
                permissionValue.access === idm_authorization_client_js_1.Access.FULL;
        }));
    };
    ChangeLogComponent.prototype.getWorkflowStateField = function (category) {
        if (this._workFlowStateFieldCache.has(category)) {
            return this._workFlowStateFieldCache.get(category);
        }
        else {
            var replaySubject_3 = new ReplaySubject_1.ReplaySubject(1);
            this._workFlowStateFieldCache.set(category, replaySubject_3);
            this._kbService
                .getMetaFields(category)
                .pipe(operators_1.map(function (metaFields) {
                var stateField = metaFields.find(function (field) {
                    return field.getType() === meta_field_1.MetaFieldType.WORKFLOW_STATE;
                });
                if (!lodash_1.isNil(stateField)) {
                    replaySubject_3.next(stateField.getSystemName());
                }
                else {
                    replaySubject_3.next('');
                }
            }), operators_1.takeUntil(this.destroyNotifier))
                .subscribe(noop_1.noop, console.error);
            return replaySubject_3;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ChangeLogComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ChangeLogComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], ChangeLogComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ChangeLogComponent.prototype, "instanceId", void 0);
    ChangeLogComponent = __decorate([
        idm_dynamic_controls_metadata_1.ControlMetadata({
            cellCount: 8,
            name: 'Change Log',
            settings: {
                main: change_log_settings_component_1.ChangeLogSettingsComponent,
            },
            template: "\n                   <change-log [id]=\"'%{id}'\"\n                   [category]=\"category\"\n                   [currentLanguageId]=\"currentLanguageId\"\n                   [entity]=\"entity\">\n                   </change-log>\n                   ",
            isFieldBound: false,
        }),
        core_1.Component({
            moduleId: module.id + '',
            selector: 'change-log',
            template: require('./change-log.component.html'),
            providers: [change_log_service_1.ChangeLogService],
        }),
        __metadata("design:paramtypes", [change_log_service_1.ChangeLogService,
            idm_de_service_client_js_1.DeService,
            router_1.Router,
            router_1.ActivatedRoute,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_authentication_client_js_1.AuthenticationService,
            idm_authorization_client_js_1.AuthorizationService,
            idm_kb_service_client_js_1.KbService])
    ], ChangeLogComponent);
    return ChangeLogComponent;
}());
exports.ChangeLogComponent = ChangeLogComponent;
//# sourceMappingURL=change-log.component.js.map